import React from 'react';

import { EllipsisBreadcrumb } from '@/shared/components/ui/ellipsis-breadcrumb/ellipsis-breadcrumb';
import { UNGROUPED_RESOURCES_GROUP_ID } from '@/shared/features/groups/components/group-list/group-list.constants';
import { TGroupAncestor } from '@/shared/features/groups/utils/group-hierarchy/group-hierarchy.types';
import { TCrumb } from '@/shared/types/router.types';

type TGroupCrumbData = string | { parent?: TGroupAncestor | null };

// Breadcrumb ancestor: ungrouped crumb, else parent (+ ellipsis to grandparent).
export const getGroupAncestorCrumb = (
  data: TGroupCrumbData,
): TCrumb | undefined => {
  if (typeof data === 'string') {
    if (data !== UNGROUPED_RESOURCES_GROUP_ID) {
      return undefined;
    }

    return {
      label: 'ungrouped_resources',
      localized: true,
      link: `groups/${UNGROUPED_RESOURCES_GROUP_ID}`,
    };
  }

  const parent = data?.parent;
  if (!parent) {
    return undefined;
  }

  const grandparentGroupId = parent.parentGroupId;

  return {
    label: parent.name,
    link: `groups/${parent.groupId}`,
    ancestor: grandparentGroupId ? (
      <EllipsisBreadcrumb linkTo={`groups/${grandparentGroupId}`} />
    ) : undefined,
  };
};
